import { z as builder } from "zod"

export const adUserByPhoneSchema = builder.object({
    phoneNumber: builder
        .string()
        .trim()
        .min(1, "Este campo es obligatorio")
        .min(10, "Ingresa un número de 10 dígitos")
        .max(10, "Ingresa un número de 10 dígitos")
        .regex(/^\d+$/, "Solo se permiten números"),
})

export type AdUserByPhoneSchema = builder.infer<typeof adUserByPhoneSchema>
